const options = { 
    method: 'GET', 
    headers: new Headers({ 
      'Content-Type': 'application/json',
      'sb-application-name': 'sb-site-ui',
      'sb-application-key': 'jmd-test',
      'sessionID' : sessionStorage.getItem("sessionID"),
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Access-Control-Allow-Origin, Access-Control-Allow-Headers, Content-Type, sb-application-name, sb-application-key, sessionID ',
    }), 
    mode: 'cors',
    credentials: 'omit'
    // body: JSON.stringify(testPayload)
  };

  export async function getModuleByID(id){

    const endpoint = process.env.REACT_APP_BFF + '/bff/v1.0/getModuleDetails/' + id;
    // options.metho?d = 'GET';
  
    // console.log("getProductByID endpoint" + endpoint);
    let moduleDetailsResponse =
      await fetch(endpoint,options)
        .then(response => {
          // console.log('getProductByIDResponse' + JSON.stringify(response.json()));
          return response.json();
        })
        .catch(function(err) {
          console.log(err);
        });

        // console.log("moduleDetailsResponse >>>> " + JSON.stringify(moduleDetailsResponse));

    return moduleDetailsResponse;

  }
